import { useCaptureAttribution } from './use-capture-attribution'

/** Mounts the attribution capture once at the app root (FE-320). */
export const AttributionEffect = () => {
  useCaptureAttribution()
  return null
}
